module.exports = __webpack_public_path__ + "assets/tiktok-logo.7330710b.svg";